




























































import { Component } from "vue-property-decorator";
import TabsComponentBase from "@/app/interaction-plugins/tabs/tabs-component-base";
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';

@Component({
  components: {}
})
export default class HorizontalTabsComponent extends TabsComponentBase {
  private get isFirst(): boolean {
    return this.selectedIndex === 0;
  }

  private get isLast(): boolean {
    const tabsCount: number = Object.keys(this.internalTabs).length;
    return this.selectedIndex >= tabsCount - 1;
  }

  private onMobileTabPrevClicked(): void {
    if (this.isFirst) {
      return;
    }

    this.selectedIndex--;
  }

  private onMobileTabNextClicked(): void {
    if (this.isLast) {
      return;
    }

    this.selectedIndex++;
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
